export const SET_POLL = 'ROOM/POLL/SET_POLL'
export const SET_POLLS = 'ROOM/POLL/SET_POLLS'
